
import { Vue, Component, Prop } from 'vue-property-decorator';
import SvgConstructor from "@/assets/icons/constructor.svg";
import SvgCancel from "@/assets/icons/cancel.svg";
import SvgTrash from "@/assets/icons/trash.svg";
import SaveBtnTooltip from "@/components/base/buttons/SaveBtnTooltip.vue";

@Component({
    components: { SaveBtnTooltip, SvgConstructor, SvgCancel, SvgTrash },
})
export default class ReportConstructorWrap extends Vue {
    @Prop({ default: true }) isShowErrors!: boolean;
    @Prop({ default: '' }) customPanelClass!: string;
    @Prop({ default: () => ({}) }) emptyConditions!: object;
    /** Максимальная ширина панели конструктора (прижата к правому краю экрана) */
    @Prop({ default: '100%' }) maxDialogWidth!: string;
    @Prop({ default: 'Сформировать' }) approveText!: string;

    isShow = false;

    created(): void {
        //искусственно тригерим создание вложенных компонентов для нужного поведения фильтров
        this.isShow = true;
        this.$nextTick(() => this.isShow = false);
    }

    get hasError(): boolean {
        return this.isShowErrors && Object.keys(this.emptyConditions).length > 0;
    }

    submit(): void {
        this.isShow = false;
        this.$emit('submit');
    }
}
